import { EnrichedProgram } from "@/common/course/types";
import { IconTypes } from "@/components/icons/types";
import { ProductCardProps } from "@/components/ProductCard/types";
import { ProgramType } from "@/common/program/types";

export function convertHitsToEnrichedPrograms(hits: ProductCardProps[]):
  | (EnrichedProgram & {
      _badges?: Array<{ label: string; icon?: IconTypes }>;
      _level?: "Introductory" | "Intermediate" | "Advanced";
    })[]
  | undefined {
  return hits.map((hit) => {
    const enrichedProgram: EnrichedProgram = {
      uuid: hit.uuid || hit.objectId || "",
      title: hit.name,
      subtitle:
        hit.hoverOverlay?.aboutThisProduct ||
        hit.hoverOverlay?.primaryDescription ||
        "",
      type: hit.type as ProgramType,
      marketingUrl: hit.href,
      externalId: hit.objectId || "",
      cardImageUrl: hit.imageUrl,
      partners: Array.isArray(hit.partnerKey)
        ? hit.partnerKey.map((name) => ({
            name,
            logoUrl: hit.partnerLogoUrl || "",
          }))
        : hit.partnerKey
          ? [{ name: hit.partnerKey, logoUrl: hit.partnerLogoUrl || "" }]
          : [],
      subjects: hit.subjects
        ? Array.isArray(hit.subjects)
          ? hit.subjects
          : [hit.subjects]
        : [],
      weeksToComplete: hit.weeksToComplete,
      pacing: hit.pacing,
    };

    return {
      ...enrichedProgram,
      _badges: hit.level
        ? [{ label: hit.level, icon: "level" as IconTypes }]
        : undefined,
      _level: hit.level as
        | "Introductory"
        | "Intermediate"
        | "Advanced"
        | undefined,
    };
  });
}
